import "./style.css";
import WebContent from "./App";

import { createRoot } from 'react-dom/client';

createRoot(document.getElementById('root')).render(<WebContent />);
